import { render, staticRenderFns } from "./KangarooIsland.vue?vue&type=template&id=2707b905&"
import script from "./KangarooIsland.vue?vue&type=script&lang=js&"
export * from "./KangarooIsland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports